<template>
    <div class="dashboard-widget-content">
        <template v-if="!value.ShowOptions">
            <chart-card-dashboard-wings no-footer>
                <line-chart :series="demoSeries()"
                           :xAxis="demoXAxis()"
                           :yAxis="yAxis"
                           tooltip-format="{b}: <b>{c}</b>"></line-chart>
            </chart-card-dashboard-wings>
        </template>
        <template v-else>
            <widget-options>
                <md-field>
                    <label>{{ $t('widget.options.update') }}</label>
                    <md-select v-model="options.update">
                        <md-option value="10 мин">10 мин</md-option>
                        <md-option value="Нет">Нет</md-option>
                    </md-select>
                </md-field>
                <md-field>
                    <label>{{ $t('widget.options.interval') }}</label>
                    <md-select v-model="options.interval">
                        <md-option value="24">последние 24 часа</md-option>
                        <md-option value="48">последние 48 часов</md-option>
                        <md-option value="yesterday">предыдущий день</md-option>
                        <md-option value="7day">последние 7 дней</md-option>
                    </md-select>
                </md-field>
                <md-field>
                    <label>{{ $t('widget.options.chanel') }}</label>
                    <md-select v-model="options.chanel">
                        <md-option value="SMS">{{$t('widget.channel.SMS')}}</md-option>
                        <md-option value="Call">{{$t('widget.channel.Call')}}</md-option>
                        <md-option value="Email">{{$t('widget.channel.Email')}}</md-option>
                        <md-option value="Push">{{$t('widget.channel.Push')}}</md-option>
                        <md-option value="Viber">{{$t('widget.channel.Viber')}}</md-option>
                    </md-select>
                </md-field>
                <md-field>
                    <label>{{ $t('widget.options.service_provider') }}</label>
                    <md-select v-model="options.service_provider">
                        <md-option value="all">Все</md-option>
                        <md-option value="MTS">MTS</md-option>
                        <md-option value="Megafon">Megafon</md-option>
                    </md-select>
                </md-field>
            </widget-options>

        </template>
    </div>
</template>

<script>
  import widgetMixin from './mixin'
  import { DateTime,Settings } from 'luxon'

  export default {
    name: "SendingProviders",
    mixins:[widgetMixin],
    props:{
      value:{},
      fullSize:{default:false}
    },
    data(){return{
      options:{
        update:'10 мин',
        interval:'24',
        chanel:'SMS',
        service_provider:'MTS',
      },
      ChartData: [10,20],
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value} %"
        }
      }
    }},
    methods:{
      title(){
        const $t = this.$t.bind(this);
        let title = $t(`widget.SendingProviders.title`)
          +' '+$t('widget.channel.'+this.options.chanel)
          +' '+this.options.service_provider;

        let current = DateTime.local();
        switch (this.options.interval) {
          case 'yesterday':
            end = current.plus({day:-1});
            title+=  ' за '+end.toFormat('dd.LL');
            break;
          case '7day':
            end = current.plus({day:-7}).set({hour:23,minute:59});
            let start = DateTime.local().plus({day:-7}).set({hour:0,minute:0});
            title+=  ' с '+start.toFormat('dd.LL');
            title+=  ' до '+end.toFormat('dd.LL');
            break;
          default:
            let end = DateTime.local().plus({hour:-this.options.interval});
            // title+=  ' c '+start.toFormat('dd.LL hh:ss');
            // title+=  ' до '+current.toFormat('dd.LL hh:ss');
            break;
        }

        return title;
      },
      randomInteger(min, max) {
        // случайное число от min до (max+1)
        let rand = min + Math.random() * (max + 1 - min);
        return Math.floor(rand);
      },

      demoXAxis(){
        let arr = [];
        let cur = DateTime.local();
        let interval = 10;
        let step = {hour:-1};
        let format = 'dd.LL hh:ss';
        switch (this.options.interval) {
          case 'yesterday':
            cur = cur.plus({day:-1}).set({hour:23,minute:59});
            interval = 24;
            break;
          case '7day':
            cur = cur.plus({day:-1}).set({hour:23,minute:59});
            format = 'dd.LL';
            interval = 7;
            step = {day:-1};
            break;
          default:
            interval = parseInt(this.options.interval) || interval;
            break;
        }
        for (let i = 0; i < interval; i++ ) {
          arr.push(cur.toFormat(format));
          cur = cur.plus(step)
        }
        return arr.reverse()
      },
      demoData(min,max){
        max = max || 100;
        min = min || 1;
        let interval = 10;
        switch (this.options.interval) {
          case 'yesterday':
            interval = 24;
            break;
          default:
            interval = parseInt(this.options.interval) || interval;
            break;
        }
        let arr = [];
        for (let i = 0; i < interval; i++ ) {
          arr.push(this.randomInteger(min,max));
        }
        return arr
      },
      demoSeries(){
        return [
          {
            type: 'line',
            name: 'Beeline',
            data: this.demoData(0,1000),
            stack: 'one',
          },
          {
            type: 'line',
            name: 'MTS',
            data: this.demoData(0,1000),
            stack: 'one',
          },
        ]
      }
    },
    created() {
      Settings.defaultLocale = this.$i18n.locale;
    }
  }
</script>
